import React from 'react';

import CalculatorCore, {Props} from './CalculatorCore';

export default class CalculatorHSC extends React.Component<Props> {
  render() {
    return <CalculatorCore {...this.props} scaledTitle="Scaled /50" />;
  }
}
